import { render } from "./CartNewItem.vue?vue&type=template&id=3fac177e"
import script from "./CartNewItem.vue?vue&type=script&lang=js"
export * from "./CartNewItem.vue?vue&type=script&lang=js"

import "./CartNewItem.vue?vue&type=style&index=0&id=3fac177e&lang=scss"
script.render = render

export default script